<template>
<div>
    
</div>
</template>

<script>
export default {
    name: 'ModalEditarConsumoBT1A'
}
</script>

<style>

</style>
